import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import supabase_client_2ruDq4uEtU from "/vercel/path0/node_modules/@nuxtjs/supabase/dist/runtime/plugins/supabase.client.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/vercel/path0/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_Jozdw60ZsE from "/vercel/path0/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import pwa_client_Eorgdr12jA from "/vercel/path0/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import plugin_iGLjBbor9q from "/vercel/path0/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import auth_redirect_bWtzICY6fh from "/vercel/path0/node_modules/@nuxtjs/supabase/dist/runtime/plugins/auth-redirect.js";
import plugin_ghbUAjaD3n from "/vercel/path0/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import i18n_yfWm7jX06p from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import element_plus_teleports_plugin_h4Dmekbj62 from "/vercel/path0/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/vercel/path0/.nuxt/element-plus-injection.plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_AUP22rrBAc from "/vercel/path0/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import Vue3Lottie_client_bMZiOS6AB0 from "/vercel/path0/plugins/Vue3Lottie.client.ts";
import airbridge_client_QjbS9u85DY from "/vercel/path0/plugins/airbridge.client.ts";
import api_GFfDXud5Cr from "/vercel/path0/plugins/api.ts";
import bridge_client_PsBxTK5Q5r from "/vercel/path0/plugins/bridge.client.ts";
import drag_scroll_yF7C9Nreeh from "/vercel/path0/plugins/drag-scroll.ts";
import errorChacher_J9UuiT8Yd4 from "/vercel/path0/plugins/errorChacher.ts";
import senitize_pAzKeR833V from "/vercel/path0/plugins/senitize.ts";
import sweetalert_close_Qm5u4cswhQ from "/vercel/path0/plugins/sweetalert-close.ts";
import sweetalert2_client_vmjArNBT49 from "/vercel/path0/plugins/sweetalert2.client.ts";
import vue_social_sharing_client_1N3fV7xgEB from "/vercel/path0/plugins/vue-social-sharing.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  supabase_client_2ruDq4uEtU,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_Jozdw60ZsE,
  pwa_client_Eorgdr12jA,
  plugin_iGLjBbor9q,
  auth_redirect_bWtzICY6fh,
  plugin_ghbUAjaD3n,
  i18n_yfWm7jX06p,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  chunk_reload_client_UciE0i6zes,
  plugin_AUP22rrBAc,
  Vue3Lottie_client_bMZiOS6AB0,
  airbridge_client_QjbS9u85DY,
  api_GFfDXud5Cr,
  bridge_client_PsBxTK5Q5r,
  drag_scroll_yF7C9Nreeh,
  errorChacher_J9UuiT8Yd4,
  senitize_pAzKeR833V,
  sweetalert_close_Qm5u4cswhQ,
  sweetalert2_client_vmjArNBT49,
  vue_social_sharing_client_1N3fV7xgEB
]